import { render, staticRenderFns } from "./Spesifikasi.vue?vue&type=template&id=5aa66124&"
import script from "./Spesifikasi.vue?vue&type=script&lang=js&"
export * from "./Spesifikasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports